import classes from './Contact-Search.module.css';
import ContactHeader from './ContactHeader/ContactHeader';
import Search from '../../Components/Search/Search';
import ShoppingCart from '../Cart/Cart';
import Navigation from '../Navigation/Navigation';
import Logo from '../../Components/Logo/Logo';

const ContactSearch = ({backgroundColor,
                        contactHeaderTextStyles,
                        contactIconStyles,
                        iconWidth,
                        iconHeight,
                        containerStyles,
                        searchFieldStyles,
                        searchCartIconStyles,
                        dropdowns=[],
                        containerClass="",
                        links=[],
                        collapsedState=false,
                        data={}
                    }) => {

    return (
        <div className={classes.container} style={{
            backgroundColor: backgroundColor,
            ...containerStyles
        }}>
            <ContactHeader textStyles={contactHeaderTextStyles}
                           data={data}
                           iconStyles={contactIconStyles}/>
            {
                collapsedState ?
                    (
                        <div className={classes.lowerCollapsedContainer}>
                            <Navigation dropdowns={dropdowns}
                                containerClass={classes.collapsedContainer}
                                navigationClass={classes.dropdownContainer}
                                dropdownHeaderClass={classes.dropdownHeader}
                                links={links} />
                            <Logo width={'50%'}/>
                            <ShoppingCart
                                      cStyles={searchCartIconStyles}
                                      containerClass={containerClass}
                                      nStyles={contactHeaderTextStyles}/>
                        </div>
                    )
                    : <div className={classes.searchCartContainer}>
                        <Search backgroundColor={backgroundColor}
                                iStyles={searchCartIconStyles}
                                iHeight={iconHeight}
                                searchFieldStyles={searchFieldStyles}
                                iWidth={iconWidth} />
                        <ShoppingCart
                                      cStyles={searchCartIconStyles}
                                      nStyles={contactHeaderTextStyles}/>
                      </div>
            }
        </div>
    );
};

export default ContactSearch;
